import React from 'react';
import {View, ViewProperties} from '@lookiero/aurora';
import {DownloadButton} from '@components/molecules/AppDownloadButtons/AppDownloadButtons';
import {Platform} from 'react-native';
import {ConfigurationApplication} from '@application/Config';
import {TradeName} from '@domain/model/Config/Configuration';
import {useLocale} from '@components/hooks';
import {Locale} from '@domain/model/Site/Locale';

interface AppDownloadSectionProps extends ViewProperties {
  title?: string;
  source?: string;
}

const isWeb = Platform.OS === 'web';
const isOutfittery = ConfigurationApplication.retrieve().tradename === TradeName.OUTFITTERY;

export const AppDownloadSection: React.FC<AppDownloadSectionProps> = ({title, source, ...rest}) => {
  const {country} = useLocale() as Locale;

  if (!isWeb || !country || (isOutfittery && country === 'ES')) return null;

  return (
    <View {...rest}>
      <DownloadButton source={source} title={title} />
    </View>
  );
};
